import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import DataTable from 'react-data-table-component';

import { getReleaseStatsByAction } from "../controllers/statisticsController";


const SubscriberStatisticsView = ({ releaseId, action }) => {
    const [total, setTotal] = useState(0);
    const perPage = 10;

    const [state, setState] = useState({
        subscribers: [],
        perPage: 10,
        page: 1,
        total: 0,
        releaseId: releaseId,
        action: action,
        current_page: 1,
    });

    useEffect(() => {
        getReleaseStatsByAction(state, (data) => {
            setState((prev) => ({
                ...prev,
                subscribers: data.subscribers,
                total: data.total
            }));
        });
    }, [state.perPage, state.current_page, state.page, releaseId, action]);

    const handlePrevious = () => {
        if (state.current_page > 1) {
            setState((prev) => ({
                ...prev,
                current_page: prev.current_page - 1,
                page: prev.page - 1
            }));
        }
    };

    const handleNext = () => {
        const maxPages = Math.ceil(state.total / state.perPage);
        if (state.current_page < maxPages) {
            setState((prev) => ({
                ...prev,
                current_page: prev.current_page + 1,
                page: prev.page + 1
            }));
        }
    };
    return (
        <div>
        <div className='card w-100 position-relative overflow-hidden'>
        <div className='card-body'>
            <div className='px-4 py-3 border-bottom'>
                <h2 className='card-title mb-0'>Over All Statistics for {action}</h2>
            </div>
            <div className='table-responsive mb-4 mt-4 border rounded-1'>
                <table className='table text-nowrap mb-0 align-middle'>
                    <thead className='text-dark fs-4'>
                        <tr>
                            <th>Subscriber ID</th>
                            <th>Emails</th>
                            <th>Action</th>
                            <th>Release Name</th>
                            <th>Device</th>
                            <th>Geo Location</th>
                        </tr>
                    </thead>
                    <tbody>
                        {state.subscribers.length > 0 ? (
                            state.subscribers.map((subscriber, index) => (
                                <tr key={index}>
                                    <td>{subscriber.subscriber_id}</td>
                                    <td>{subscriber.email}</td>
                                    <td>{subscriber.action}</td>
                                    <td>{subscriber.release_name}</td>
                                    <td>{subscriber.device}</td>
                                    <td>{subscriber.geo_location}</td>
                                </tr>
                            ))
                        ) : (
                            <li>No subscribers found.</li>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="d-flex align-items-center gap-3 mt-3">
                <button disabled={state.current_page === 1} onClick={handlePrevious} className='btn btn-primary'>
                    Previous
                </button>
                <span>Page {state.current_page}</span>
                <button
                    disabled={state.current_page * state.perPage >= state.total}
                    onClick={handleNext}
                    className='btn btn-primary'
                >
                    Next
                </button>
            </div>
        </div>
        </div>
        </div>
    );

};

export default SubscriberStatisticsView;
